module.exports = __webpack_public_path__ + "img/slide1.a5929101.png";